import { base64URLEncode, sha256 } from "./sha256-base64-url-encode"
import createCodeVerifier from './create-code-verifier'
import hashed from './hashed'
import getEncodedVerifierKey from './getEncodedVerifierKey'
import { pkceChallenge } from '../codeVerifierChallenge/sync-pkce-challenge';
import { redirectURIPath } from '../../Services/config/apiGateway';


export default function authorize({
  provider,
  clientId,
  scopes,
  storage = sessionStorage
}) {
  const verifierChallenge = pkceChallenge();

  const redirect_uri = window.location.toString()

  //const encodedVerifier = base64URLEncode(createCodeVerifier())
  const encodedVerifier = verifierChallenge.codeVerifier
  storage.setItem(
    getEncodedVerifierKey(clientId),
    JSON.stringify({
      encodedVerifier,
      redirect_uri
    })
  )
  storage.setItem('_Verenc',encodedVerifier)

  const query = {
    //client_id: clientId,
    // response_type: 'code',
    // response_mode:'query',
    redirect_uri:redirectURIPath,
    // redirect_uri:"https://www.dev-cargoconnectadmin.transnetportterminals.net",
    // redirect_uri:"https://www.test-cargoconnectadmin.transnetportterminals.net",
    //  redirect_uri:"http://localhost:3000",
    //code_challenge: base64URLEncode(sha256(encodedVerifier)),
    code_challenge:verifierChallenge.codeChallenge,
   // code_challenge:'ocYCWfMwcSjWZok91g7EAZsKLdqPI7Nn_qoUWIdHHM4',
    code_challenge_method: 'S256',
  }

  // if (scopes && scopes.length > 0) {
  //   query.scope = scopes.join(' ')
  // }
  
  //const url = `${ provider }/authorize?${ hashed(query) }`
  //const url = `${ provider }`

  const url = `${ provider }${ hashed(query) }`
  window.location.replace(url)
}
